<template>
  <section class="main-content">

    <section class="main-content__full section">
      <header class="section__header">
        <h1 v-if="getFormat" class="section__title">{{ getFormat.name }}</h1>
        <section class="section__header__area">
          <p class="section__title"></p>
        </section>
      </header>
    </section>
    <aside class="main-content__side demo__main--side section">
      <demo-links @clicked="handleSelection" class="section__content categories"></demo-links>
    </aside>

    <section v-on:scroll="handleScroll" class="main-content__main demo__main section">
      <demo-listing :adformat="getFormat" class="section__content"></demo-listing>
    </section>
  </section>
</template>

<script>
  import DemoLinks from './demo/DemoLinks'
  import DemoListing from './demo/DemoListing'

  export default {
    name: 'Demo',
    components: {
      demoLinks: DemoLinks,
      demoListing: DemoListing
    },
    methods: {
      handleScroll (event) {

      },
      handleSelection (index) {
        let scrollHeight = 0;
        let demoitems = document.getElementsByClassName('demo__item');
        for (var i = 0; i < demoitems.length; i++) {
          if (i < index) {
            scrollHeight += demoitems[i].clientHeight
          }
        }
        document.getElementsByClassName('main-content__main')[0].scroll({
          top: scrollHeight,
          left: 0,
          behavior: 'smooth'
        })
      }
    },
    computed: {
      getFormat () {
        if (!this.adFormat) {
          let id = this.$route.params.format_id;
          let ads = this.$store.getters['formats/unfiltered'];
          ads.find(ad => {
            if (ad.id == id) {
              this.adFormat = ad
            }
          })
        }
        return this.adFormat
      },
    },
    data () {
      return {
        adFormat: null,
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../scss/index';
  .section {
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Demo.vue